export default __webpack_public_path__ + "static/bf-logo-30511d6f3a0dbd42937fe6c0e53306ef.png";